export default {
  getApprovalResponse: (state) => state.approvalResponse,
};
